import { MotorQuotationInterface } from "./../../interface/motor-quotation.interface";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class MotorQuotationDataService {
  private basePath: string = `${environment.url}/api/Microsite/`;

  constructor(private http: HttpClient) {}

  submit(request: MotorQuotationInterface) {
    return this.http.post<MotorQuotationResponse>(
      `${this.basePath}Submit`,
      request
    );
  }

  submitRequest(request: MotorQuotationInterface) {
    return this.http.post<MotorQuotationResponse>(
      `${this.basePath}SubmitRequest`,
      request
    );
  }

  submitCustomerInfo(request: SubmitCustomerInfoRequest) {
    return this.http.post(`${this.basePath}InsertCustomerInfo`, request);
  }

  checkEligibilityForGamification(request: SubmitCustomerInfoRequest) {
    return this.http.post<{isEligible: boolean}>(
      `${this.basePath}CheckEligibilityForGamification`, request);
  }

  generateNewUserVoucherCodeSendEmail(request: NewUserVoucherRequest) {
    return this.http.post<number>(
      `${this.basePath}GenerateNewUserVoucherCodeSendEmail`, request);
  }

  submitExtraProduct(id: string, typeOfSum: string, idList: string[]) {
    return this.http.post(`${this.basePath}SubmitExtraProduct/${id}`, {
      typeOfSum,
      selectedMotorProductIds: idList
    });
  }

  checkDuplicateRequest(request: CheckDuplicateRequest) {
    return this.http.post<CheckDuplicateResponse>(
      `${this.basePath}CheckDuplicateRequest`,
      request
    );
  }
}

interface MotorQuotationResponse {
  isSuccess: boolean;
  isVehicleOverage: boolean;
  isTpftVehicleOverage: boolean;
  isEhailing: boolean;
  data: string;
  redirect_url: string;
}

export interface CheckDuplicateResponse {
  isExist: "Y" | "N";
  isLinkExist: "Y" | "N";
}

export interface CheckDuplicateRequest {
  vehicleNo: string;
  identityNo: string;
  email: string;
  mobileNo: string;
  postcode: string;
  eHailingUsed: boolean;
  preferredChannel: string;
}

export interface SubmitCustomerInfoRequest {
  vehicleNo: string;
  postcode: string;
  mobileNo: string;
  email: string;
  isMalaysian: boolean;
  isCompany: boolean;
  isCommercialIndividual: boolean;
  isCommercialCompany: boolean;
  name: string;
  identityNo: string;
  policIdentityNo: string;
  dob: Date;
  gender: string;
  nationality: string;
}

export interface NewUserVoucherRequest {
  email: string;
  vehicleNo: string;
  identityNo: string; 
  language: string;
}
